/* INFINITE SCROLL CHANGE START: collection page auto-load next pagination page */
(function () {
  function initInfiniteScroll(scope) {
    var root = scope || document;
    var grid = root.querySelector('[data-infinite-grid]');
    var nextLink = root.querySelector('[data-infinite-next]');
    var sentinel = root.querySelector('[data-infinite-sentinel]');
    var pagination = root.querySelector('[data-infinite-pagination]');

    if (!grid || !nextLink || !sentinel) return;

    var nextUrl = nextLink.getAttribute('href');
    var loading = false;

    var loader = root.querySelector('[data-infinite-loader]');
    var MIN_LOADER_MS = 800;

function setLoading(state) {
  if (loader) loader.hidden = !state;
}

    // INFINITE SCROLL CHANGE: hide normal pagination when JS is active
    if (pagination) pagination.style.display = 'none';

   function loadNextPage() {
  if (!nextUrl || loading) return;
  loading = true;
  setLoading(true);
  var start = Date.now();

  fetch(nextUrl, { credentials: 'same-origin' })
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var incomingGrid = doc.querySelector('[data-infinite-grid]');
      if (!incomingGrid) {
        observer.disconnect();
        return;
      }

      Array.prototype.forEach.call(incomingGrid.children, function (node) {
        grid.appendChild(node);
      });

      var newNextLink = doc.querySelector('[data-infinite-next]');
      nextUrl = newNextLink ? newNextLink.getAttribute('href') : null;

      if (!nextUrl) observer.disconnect();
    })
    .catch(function () {
      if (pagination) pagination.style.display = '';
      observer.disconnect();
    })
    .finally(function () {
      var elapsed = Date.now() - start;
      var wait = Math.max(0, MIN_LOADER_MS - elapsed);
      setTimeout(function () {
        loading = false;
        setLoading(false);
      }, wait);
    });
}


    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '80px 0px' });

    observer.observe(sentinel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initInfiniteScroll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initInfiniteScroll(event.target);
  });
})();
/* INFINITE SCROLL CHANGE END */
